"use strict";

exports.__esModule = true;
exports["default"] = getPositionClass;
function getPositionClass(_ref) {
  var fontFamily = _ref.fontFamily,
    styles = _ref.styles;
  var fontFamilyString = fontFamily && fontFamily.split(',').join('');
  fontFamilyString = fontFamilyString && fontFamilyString.split(' ').join('-').toLowerCase();
  return fontFamilyString && styles[fontFamilyString];
}